import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Spinner from './Spinner';

function Layout({ children }) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    // Hide spinner after page loads
    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 100);
    }

    // Initialize Bootstrap dropdowns and collapse
    const initBootstrap = () => {
      // Bootstrap will auto-initialize dropdowns and collapse
      // But we need to ensure the mobile menu works
      const menuToggle = document.querySelector('.tgh-menu-toggle');
      const navbar = document.querySelector('#mainNavbar');
      
      if (menuToggle && navbar) {
        menuToggle.addEventListener('click', () => {
          const bsCollapse = new window.bootstrap.Collapse(navbar, {
            toggle: true
          });
        });
      }
    };

    // Wait for Bootstrap to load
    if (window.bootstrap) {
      initBootstrap();
    } else {
      window.addEventListener('load', initBootstrap);
    }

    return () => {
      window.removeEventListener('load', initBootstrap);
    };
  }, []);

  return (
    <>
      <Spinner />
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default Layout;
